import "core-js/modules/es.object.values.js";
var periods = {
  M0: {
    id: 'M0',
    label: 'Año actual'
  },
  M12: {
    id: 'M12',
    label: '1 año'
  },
  M24: {
    id: 'M24',
    label: '2 años'
  },
  M36: {
    id: 'M36',
    label: '3 años'
  },
  M60: {
    id: 'M60',
    label: '5 años'
  },
  M120: {
    id: 'M120',
    label: '10 años'
  }
};
var getPeriodsList = function getPeriodsList() {
  return Object.values(periods);
};
export { periods, getPeriodsList };